(() => {
  if (window.__nkMenuBannerInstalled) return;
  window.__nkMenuBannerInstalled = true;

  const selector = '.eq-header-mobile-promo__link';
  const handledClicks = new WeakSet();

  function handlePromoClick(event) {
    if (!event.target || event.target.nodeType !== 1) return;

    const link = event.target.closest(selector);
    if (!link || handledClicks.has(event)) return;
    handledClicks.add(event);

    const destination = link.getAttribute('href') || '';
    const promoItems = document.querySelectorAll(selector);
    const position = Array.from(promoItems).indexOf(link) + 1;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'menu_banner_click',
      banner_destination: destination,
      banner_position: position,
    });

    // Live's Tuesday-promotion event is separate from the older banner event.
    // Emit it only for the actual displayed Tuesday promotional card.
    if (destination.startsWith('/collections/2-tuesdays') && link.getClientRects().length) {
      window.dataLayer.push({
        event: 'mobile_nav_promo_click', location_id: 'mobile_nav',
        click_text: '£2 Tuesdays is back!', link_url: destination,
        element_position: position,
      });
    }
  }

  document.addEventListener('click', handlePromoClick, true);

  // Keep the existing header tracking owner instead of introducing a second
  // global analytics bundle. These listeners READ the native Horizon UI only.
  const clean = (node) => node?.textContent?.replace(/\s+/g, ' ').trim() || '';
  const pageType = () => window.ShopifyAnalytics?.meta?.page?.pageType ||
    (location.pathname === '/' ? 'home' : 'other');
  const fields = () => ({ location_id: 'header', page_type: pageType(), page_path: location.pathname });
  const push = (event, attrs = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...attrs });
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const header = target.closest('#header-component');
    if (!header) return;

    if (target.closest('.header__icon--menu.header__icon--summary')) {
      // Only a genuine burger tap counts. The mobile search icon opens the same drawer via a synthetic
      // summary.click() (eq-header-search-trigger.js), whose event is untrusted — skip it so the search
      // icon reports header_search_open only, matching live. Native details toggles after this handler,
      // so a closed details means we are opening.
      if (event.isTrusted && !target.closest('details')?.open) push('header_menu_open', fields());
      return;
    }
    if (target.closest('.eq-header-search__button')) {
      push('header_search_open', fields());
      return;
    }
    if (target.closest('a.header-logo')) {
      push('header_logo_click', fields());
      return;
    }
    if (target.closest('header-actions [data-testid="cart-drawer-trigger"], header-actions a.action__cart')) {
      const count = Number(document.querySelector('#cart-bubble-text')?.textContent?.match(/\d+/)?.[0] || 0);
      push('header_cart_click', { ...fields(), cart_item_count: count });
      return;
    }
    const wholesale = target.closest('a.eq-header-drawer__account[href*="business.nikura.com"]');
    if (wholesale instanceof HTMLAnchorElement) {
      push('mobile_nav_wholesale_click', {
        location_id: 'mobile_nav', click_text: clean(wholesale),
        link_url: wholesale.getAttribute('href') || '',
      });
      return;
    }
    if (target.closest('header-actions .account-button, .eq-header-drawer__account')) {
      push('header_account_click', {
        ...fields(), logged_in: window.ShopifyAnalytics?.meta?.page?.customerId ? 'true' : 'false',
      });
      return;
    }

    const nav = target.closest('.eq-header-mobile-nav__link, .eq-header-menu__desktop-link');
    if (nav instanceof HTMLAnchorElement && /misti\s+diffuser/i.test(clean(nav))) {
      push('nav_pill_click', {
        location_id: 'main_nav_pill', link_text: clean(nav),
        link_url: nav.getAttribute('href') || '', page_type: pageType(),
      });
      return;
    }

    const mobileCategory = target.closest('a.eq-header-drawer__link');
    if (mobileCategory instanceof HTMLAnchorElement) {
      push('mobile_nav_category_click', {
        location_id: 'mobile_nav', click_text: clean(mobileCategory),
        link_url: mobileCategory.getAttribute('href') || '',
        section: '',
      });
      return;
    }
  }, true);

  // menu_search, as live's nk_home_mobile_events.js: only the mobile search (live has no desktop one).
  // The drawer opens from the burger ('menu_search' entry) or the mobile search icon ('header_search_icon');
  // its field is #eq-header-drawer-search-input. focus and type are sent once per visit, type after a 1 s pause.
  const searchInput = '#eq-header-drawer-search-input';
  let searchEntry = null;
  let searchFocused = false;
  let searchTyped = false;
  let typeTimer = null;
  const searchTerm = (input) => input?.value?.replace(/\s+/g, ' ').trim() || '';
  const searchPush = (action, input) => {
    if (!searchEntry) return;
    push('menu_search', { location_id: searchEntry, action, search_term: searchTerm(input) || undefined });
  };

  // On window: Horizon's document-level on:click opens the modal and focuses the input before a document listener runs.
  window.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    // A genuine burger tap makes the drawer's field the 'menu_search' entry, as live. The search icon
    // opens the same drawer via a synthetic (untrusted) summary.click(); ignore that here so it does not
    // overwrite the 'header_search_icon' entry the icon's own click sets below.
    if (event.isTrusted && target.closest('.header__icon--menu.header__icon--summary')) {
      searchEntry = 'menu_search';
      return;
    }
    const search = target.closest('.eq-header-search');
    if (!search?.querySelector('.eq-header-search__button')?.contains(target)) return;
    if (search.classList.contains('eq-header-search--drawer')) searchEntry = 'menu_search';
    else if (search.classList.contains('eq-header-search--mobile')) searchEntry = 'header_search_icon';
    else searchEntry = null;
  }, true);
  // toggle does not bubble, so capture it. Closing the drawer ends the visit's entry point.
  document.addEventListener('toggle', (event) => {
    const details = event.target instanceof HTMLDetailsElement ? event.target : null;
    if (details && !details.open && details.querySelector(searchInput)) searchEntry = null;
  }, true);
  document.addEventListener('focusin', (event) => {
    const input = event.target instanceof Element ? event.target.closest(searchInput) : null;
    if (!input || searchFocused) return;
    searchFocused = true;
    searchTyped = false;
    searchPush('focus', input);
  }, true);
  document.addEventListener('focusout', (event) => {
    if (event.target instanceof Element && event.target.closest(searchInput)) searchFocused = false;
  }, true);
  document.addEventListener('input', (event) => {
    const input = event.target instanceof Element ? event.target.closest(searchInput) : null;
    if (!input || searchTyped) return;
    clearTimeout(typeTimer);
    typeTimer = setTimeout(() => {
      if (searchTyped || !searchTerm(input)) return;
      searchTyped = true;
      searchPush('type', input);
    }, 1000);
  }, true);
  document.addEventListener('submit', (event) => {
    const input = event.target instanceof HTMLFormElement ? event.target.querySelector(searchInput) : null;
    if (!input) return;
    clearTimeout(typeTimer);
    searchPush('submit', input);
  }, true);
})();
